function isStatusRedirect(status) {
  return status === 301 || status === 302 || status === 303 || status === 307 || status === 308;
}
export {
  isStatusRedirect
};
//# sourceMappingURL=isStatus.js.map
